import { AxiosError } from "axios";
import axios from "axios";

export interface ErrorResponse {
  error?: string;
  message?: string;
  statusCode?: number;
  errors?: Record<string, string[]>;
}

export function getErrorMessage(error: unknown): string {
  if (error instanceof Error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;

      // Handle validation errors
      if (axiosError.response?.data?.errors) {
        const errors = Object.values(axiosError.response.data.errors).flat();
        return errors[0] || "Validation error occurred";
      }

      // Handle standard API errors
      if (axiosError.response?.data?.error) {
        return axiosError.response.data.error;
      }

      // Use server-provided message before falling back to generic status messages
      // (e.g. login 401 returns { message: "Invalid credentials" } — not "Session expired")
      if (axiosError.response?.data?.message) {
        return axiosError.response.data.message;
      }

      // Handle network errors
      if (axiosError.code === "ECONNABORTED") {
        return "Request timeout. Please try again.";
      }

      if (!axiosError.response) {
        return "Network error. Please check your connection.";
      }

      // Handle common HTTP status codes
      switch (axiosError.response.status) {
        case 401:
          return "Authentication failed. Please check your credentials and try again.";
        case 403:
          return "You do not have permission to perform this action.";
        case 404:
          return "The requested resource was not found.";
        case 422:
          return "Invalid data provided.";
        case 429:
          return "Too many requests. Please try again later.";
        case 500:
          return "An internal server error occurred. Please try again later.";
        default:
          return axiosError.message || "An unexpected error occurred";
      }
    }
    return error.message;
  }
  return "An unexpected error occurred";
}
